import { useContext, useEffect } from 'react';
import { GlobalsContext } from '../../../../components/Context/globalsContext';

export default function LargeFirmWelcome() {
    const { state: globalsContext } = useContext(GlobalsContext);
    const renderHtml = (htmlTag) => {
        return { __html: htmlTag };
    };

    return (
        <>
            <div className='grid grid-cols-1 lg:grid-cols-2 gap-4'>
                <div className='px-4'>
                    <div className='px-4'>
                        <h3>Welcome</h3>
                        <div dangerouslySetInnerHTML={renderHtml(globalsContext?.globals?.welcomeParagraph)}></div>
                    </div>
                </div>
                <div className='px-4'>
                    <div className='px-4'>
                        <h3>Special Announcements</h3>
                        {globalsContext?.globals?.specialAnnouncements.map((announcement, index) => {
                            return (
                                <div key={index}>
                                    <h4 dangerouslySetInnerHTML={renderHtml(announcement?.announcementHeader)}></h4>

                                    <div dangerouslySetInnerHTML={renderHtml(announcement?.announcementText)}></div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            </div>
        </>
    );
}
